// Lives under config/ so BadgeHelper can read it after the slug build deletes client/
import LABELS_BY_TOKEN from "../../../../config/badge_status_tokens.json"

export const STATUS_TOKENS = Object.fromEntries(
  Object.entries(LABELS_BY_TOKEN).flatMap(([token, labels]) =>
    labels.map((label) => [label, token])
  )
)

const normalize = (status) =>
  String(status ?? "")
    .replace(/_/g, " ")
    .trim()
    .toLowerCase()

const TOKENS_BY_NORMALIZED_LABEL = Object.fromEntries(
  Object.entries(STATUS_TOKENS).map(([label, token]) => [
    normalize(label),
    token,
  ])
)

export const statusToken = (status) =>
  TOKENS_BY_NORMALIZED_LABEL[normalize(status)] ?? "neutral"

export const statusToneClassName = (status) =>
  `badge-tone-${statusToken(status)}`

export const statusBadgeClassName = (status) =>
  `badge-tone ${statusToneClassName(status)}`
